<header
  class="sticky top-0 z-50 border-b border-white/5 bg-surface-950/80 backdrop-blur-xl"
>
  <div class="container-page flex h-16 items-center gap-3 lg:h-18">
    <a href="#inicio" class="flex min-w-0 items-center gap-2 text-sm font-bold tracking-tight sm:text-base">
      <span class="text-brand-400">&lt;/&gt;</span>
      <span>
        Benji <span class="text-brand-400">Rodríguez</span>
      </span>
    </a>

    <nav class="hidden items-center gap-5 xl:gap-7 lg:flex lg:flex-1 lg:justify-center" aria-label="Principal">
      @for (item of navItems; track item.href) {
        <a
          [href]="item.href"
          class="text-sm font-medium text-ink-400 transition hover:text-ink-100"
        >
          {{ i18n.t()[item.labelKey] }}
        </a>
      }
    </nav>

    <div class="ml-auto flex shrink-0 items-center gap-2 sm:gap-3">
      <div class="hidden sm:flex items-center rounded-xl border border-white/10 text-xs font-semibold">
        <button
          type="button"
          class="rounded-l-xl px-2 py-1 transition"
          [class.bg-brand-500/20]="i18n.language() === 'es'"
          [class.text-brand-300]="i18n.language() === 'es'"
          [class.text-ink-500]="i18n.language() !== 'es'"
          (click)="i18n.setLanguage('es')"
        >
          ES
        </button>
        <button
          type="button"
          class="rounded-r-xl px-2 py-1 transition"
          [class.bg-brand-500/20]="i18n.language() === 'en'"
          [class.text-brand-300]="i18n.language() === 'en'"
          [class.text-ink-500]="i18n.language() !== 'en'"
          (click)="i18n.setLanguage('en')"
        >
          EN
        </button>
      </div>

      <div class="hidden sm:block">
        <app-button variant="outline" [href]="cvPath" [download]="cvFilename">
          <svg class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A1.5 1.5 0 004.5 20.25h15a1.5 1.5 0 001.5-1.5V16.5M7.5 12l4.5 4.5L16.5 12M12 3.75v12.75" />
          </svg>
          <span>CV</span>
        </app-button>
      </div>

      <button
        type="button"
        class="hidden h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-white/20 bg-white/5 text-ink-100 transition hover:border-brand-400/40 max-lg:inline-flex"
        [attr.aria-expanded]="menuOpen"
        aria-controls="mobile-menu"
        [attr.aria-label]="i18n.t().openMenu"
        (click)="menuToggle.emit()"
      >
        @if (menuOpen) {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        } @else {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5" />
          </svg>
        }
      </button>
    </div>
  </div>
</header>
